<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="slu-cohort-students"
            :items="tableData"
            :fields="studentFields"
            :show-empty="true">
            <template v-slot:options>
                <b-form-select
                    class="apprentice-primary-select las-type-filter"
                    v-model="selectedLasType"
                    :options="LasTypeOptions">
                </b-form-select>
            </template>
            <template v-slot:cell(progress)="data">
                <b-progress :max="data.item.totalHours">
                    <b-progress-bar
                        v-b-tooltip.hover
                        :value="data.item.completedHours"
                        :label="`${((data.item.completedHours / (data.item.totalHours + data.item.completedBonusHours)) * 100).toFixed(0)}%`"
                        :title="$t('slu_dashboard.completed_hours')"
                        variant="primary">
                    </b-progress-bar>
                    <b-progress-bar
                        v-b-tooltip.hover
                        v-if="data.item.completedBonusHours > 0"
                        :value="data.item.completedBonusHours"
                        :label="`${((data.item.completedBonusHours / (data.item.totalHours + data.item.completedBonusHours)) * 100).toFixed(0)}%`"
                        :title="$t('slu_dashboard.completed_bonus_hours')"
                        variant="success">
                    </b-progress-bar>
                </b-progress>
            </template>
            <template v-slot:cell(action)="data">
                <div class="management-actions">
                    <b-button
                        class="btn-open btn-open-student btn-"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('common.open')"
                        @click="openStudent(data.item.id)">
                    </b-button>
                </div>
            </template>

            <template #empty>
                <div class="not-found with-header attachments-list">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('slu_dashboard.no_students_found') }}</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-slu-cohort-students-tab-component',
    props: ['sluCourseIn', 'sluCohortIn'],
    data() {
        return {
            sluCourse: this.sluCourseIn,
            sluCohort: this.sluCohortIn,
            students: this.sluCohortIn.users,
            studentFields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'progress',
                    label: this.$t('slu_dashboard.progress'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
            max: 100,
            value: 67,
            selectedLasType: null,
        };
    },
    computed: {
        tableData() {
            let users = null;
            if (this.selectedLasType) {
                let lasGroup0 = this.sluCohort.las_groups.find((group) => group.name === this.selectedLasType);
                let lasGroup1 = this.sluCohort.las_main_groups.find((group) => group.name === this.selectedLasType);
                let lasGroup2 = lasGroup0 ? lasGroup0 : lasGroup1;
                let userIdArray = lasGroup2.students.map((student) => student.user_id);
                users = this.sluCohortIn.users.filter((user) => userIdArray.includes(user.id));
            } else {
                users = this.sluCohortIn.users;
            }
            return users.map((user) => {
                const totalHours = this.sluCohortIn.modules
                    .map((module) => {
                        return module.required ? module.hours : 0;
                    })
                    .reduce((partialSum, a) => partialSum + a, 0);

                let completedHours = 0;
                let completedBonusHours = 0;
                user.slu_module_records
                    .filter((record) => record.completed)
                    .forEach((record) => {
                        if (record.slu_module.required) {
                            completedHours += record.slu_module.hours;
                        } else {
                            completedBonusHours += record.slu_module.hours;
                        }
                    });
                return {
                    id: user.id,
                    full_name: user.full_name,
                    totalHours: totalHours,
                    completedHours: completedHours,
                    completedBonusHours: completedBonusHours,
                };
            });
        },
        LasTypeOptions() {
            let lasGroups = [...this.sluCohortIn.las_groups, ...this.sluCohortIn.las_main_groups];
            let returnGroups = lasGroups.map((group) => {
                return {
                    value: group.name,
                    text: group.name,
                };
            });
            returnGroups.unshift({ value: null, text: this.$t('slu_dashboard.everything') });

            return returnGroups;
        },
    },
    methods: {
        openStudent(userId) {
            window.location.href = this.routes.sluStudentCourse(userId, this.sluCourse.id);
        },
    },
};
</script>

<style scoped lang="scss">
.las-type-filter {
    margin-bottom: 0;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .slu-cohort-students ::v-deep {
        .apprentice-table-header {
            flex-direction: row;
        }

        .apprentice-table-filters {
            margin-bottom: 0;

            input {
                flex: 0 0 auto;
            }
        }

        .apprentice-table-filters,
        .apprentice-data-table-actions {
            flex: 0 0 auto;
        }
    }

    .las-type-filter {
        width: auto;
        max-width: 250px;
    }
}
</style>
